__turbopack_context__.v({
  "className": "MkHUdq_className",
  "variable": "MkHUdq_variable",
});
